import { render } from "./UpdParam.vue?vue&type=template&id=68e87a22&scoped=true"
import script from "./UpdParam.vue?vue&type=script&lang=js"
export * from "./UpdParam.vue?vue&type=script&lang=js"

import "./UpdParam.vue?vue&type=style&index=0&id=68e87a22&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e87a22"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm});
